var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "leftcolumn" } }, [
    _c("div", { staticClass: "main" }),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "logo-box" }, [
        _c(
          "a",
          {
            staticClass: "logo",
            class: { active: this.$route.name == "officialHome" },
            on: {
              click: function ($event) {
                return _vm.Jump("/official/home")
              },
            },
          },
          [_vm._v("CS:GO")]
        ),
      ]),
      _c("div", { staticClass: "nav" }, [
        _c(
          "div",
          {
            staticClass: "nav_item box",
            on: {
              click: function ($event) {
                return _vm.Jump("/official/case")
              },
            },
          },
          [_c("div", { staticClass: "text" }, [_vm._v("开箱")])]
        ),
      ]),
      _c("div", { staticClass: "out" }, [
        _c("div", { staticClass: "out_pic", on: { click: _vm.toEgg } }),
        _c("p", [_vm._v("关闭")]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }